<template>
    <div class="mg-t-20 mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div class="row justify-content-center">
			<div v-if="submitted" class="col-md-6">
				<div class="card text-center shadow-sm">
					<div class="card-body">
						<div class="justify-content-center align-content-center">
							<div class="wd-100 wd-sm-100 mx-auto mg-b-40">
								<img :src="tick" alt="" class="img-fluid">
							</div>
						</div>

						<h5 class="card-title">{{ transactionType }} Request Submitted Successfully</h5>
						<p class="card-text">
							We have received your {{ transactionType }} instruction. An email has been sent to you.
						</p>
					</div>
				</div>
				<div class="col-12 mg-t-20 text-center">
                    <router-link class="btn btn-default wd-lg-200 mx-auto shadow-sm" :to="{ name: 'portfolio.details', params: { portfolio: $route.params.portfolio } }">Go Back</router-link>
				</div>
			</div>
			<div v-else class="col-lg-4 col-md-8">
				<div v-if="portfolio" class="card shadow-sm">
					<div class="card-header pb-0 bd-b-0">
						<h5 class="card-title">Fixed Income Transaction Request</h5>
                        <h6 class="card-subtitle mb-2 text-muted">
                            Please review the <a href="#">attached pricing</a> guidance which provides an indication of current market yields. 
                            Our traders will contact you to finalise the terms of your transaction after you submit this form.
                        </h6>
					</div>
					<div class="card-body">
						<form class="row" @submit.prevent="submitRequest">
							<div class="form-group col-lg-12 col-md-6">
								<label>Request Type</label>
								<select v-model="form.type" class="form-control custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('type') }">
									<option selected :value="null" disabled>Select an option</option>
									<option value="buy">Buy</option>
									<option value="sell" :disabled="!canSell">Sell</option>
								</select>
								<has-error :form="form" field="type"></has-error>
							</div>

							<div class="form-group col-lg-12 col-md-6">
								<label>Amount</label>
								<div class="input-group shadow-sm">
									<div class="input-group-prepend value">
										<span class="input-group-text">{{ form.currency|placeholder('') }}</span>
									</div>
									<input v-model="form.amount" type="number" step="any" class="form-control" :class="{ 'is-invalid': form.errors.has('amount') }" placeholder="0.00">
								</div>
								<has-error :form="form" field="amount" :class="'d-block'"></has-error>
							</div>

                            <div class="form-group col-lg-12 col-md-6">
								<label>Duration (years)</label>
								<input v-model="form.duration" type="number" min="0"  class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('duration') }" placeholder="Enter number of years">
								<has-error :form="form" field="duration"></has-error>
							</div>

                            <div class="form-group col-lg-12 col-md-6">
								<label>Annual Return (%)</label>
								<input v-model="form.annual_return" type="number" min="0" step="any" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('annual_return') }" placeholder="Enter annual return">
								<has-error :form="form" field="annual_return"></has-error>
							</div>

							<div class="col-12 mt-3">
								<div class="float-right">
									<button-component :busy="form.busy" :label="'Submit Request'" :label-loading="'Pleasw wait...'" :button-class="'btn btn-default shadow-sm'"></button-component>
									<router-link class="btn btn-primary shadow-sm" :to="{ name: 'portfolio.details', params: { portfolio: $route.params.portfolio } }">Cancel</router-link>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	@media (max-width: 425px) {
		.float-right {
			float: none !important;
			display: flex;
		}

		.btn:last-child {
			margin-left: 1rem;
		}

		.btn {
			width: 50%;
		}
	}
</style>

<script>
	import tick from '../../../../../img/tick.svg'

	export default {
		beforeRouteEnter(to, from, next) {
			axios
				.get(`/api/portfolio/${to.params.portfolio}`)
				.then((response) => {
					const portfolio = response.data.data.portfolio;

					if (!_.isEmpty(portfolio)) {
						next((vm) => vm.setData(null, portfolio));
					}
				})
				.catch((error) => {
					next((vm) => vm.setData(error, null));
				});
		},
		data() {
			return {
				tick,
				submitted: false,
				error: null,
				portfolio: null,
				max_units: 0,
				form: new Form({
					amount: null,
					duration: null,
					annual_return: null,
					currency: null,
					portfolio_id: null,
					client: null,
					type: null,
				}),
			};
		},
		watch: {
			portfolio: function () {
				this.form.fill({
					amount: null,
					duration: null,
					annual_return: null,
					currency: this.portfolio.currency,
					portfolio_id: this.portfolio.external_portfolio_id,
					client: this.portfolio.external_client_id,
					type: null,
				});
			},
			"form.type"(value) {
				this.transactionType = _.startCase(value);
			},
		},
		computed: {
			canSell() {
				const holdings = this.portfolio.holdings;

				return !_.isEmpty(_.filter(holdings, ["security_details.type", 1]));
			},
		},
		methods: {
			submitRequest() {
				this.form.post("/api/requests").then(({ data }) => {
					this.submitted = true;
				});
			},
			setData(err, portfolio) {
				if (err) {
					this.error = err.toString();
				} else {
					this.portfolio = portfolio;
				}
			},
		},
	};
</script>
